/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { getPayloadObject, getTelemetryAttributes, IPayLoad, UncontrolledTooltip } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ActionToggle } from '../action-toggle';
import { LocalizationConstants } from '../helper';
import { IPlayPauseTriggerProps } from './play-pause-trigger.props';

/**
 *
 * PlayPauseTrigger React component for video player.
 *
 */
export default class PlayPauseTrigger extends React.PureComponent<IPlayPauseTriggerProps> {
    public static defaultProps: Partial<IPlayPauseTriggerProps> = {
        playAriaLabel: 'play',
        pauseAriaLabel: 'pause'
    };

    private readonly playRef: React.RefObject<HTMLButtonElement> = React.createRef<HTMLButtonElement>();

    private readonly pauseRef: React.RefObject<HTMLButtonElement> = React.createRef<HTMLButtonElement>();

    private readonly payLoad: IPayLoad;

    public constructor(props: IPlayPauseTriggerProps) {
        super(props);
        this.payLoad = getPayloadObject('click', this.props.telemetryContent!, '');
    }

    public render(): JSX.Element {
        const { className, playAriaLabel, pauseAriaLabel, style, ...props } = this.props;
        this.payLoad.contentAction.etext = this.props.toggled ? LocalizationConstants.pauseAriaLabel : LocalizationConstants.playAriaLabel;
        const attribute = getTelemetryAttributes(this.props.telemetryContent!, this.payLoad);
        return (
            <div className={`${className}__container`} onClick={this.props.onChange} style={style} role='none'>
                <ActionToggle className={this.props.className} {...props}>
                    <button aria-label={playAriaLabel} className={`${className}__playbtn`} ref={this.playRef} {...attribute} />
                    <button aria-label={pauseAriaLabel} className={`${className}__pausebtn`} ref={this.pauseRef} {...attribute} />
                </ActionToggle>
                <UncontrolledTooltip trigger='hover focus' target={this.playRef}>
                    {' '}
                    {playAriaLabel}
                </UncontrolledTooltip>
                <UncontrolledTooltip trigger='hover focus' target={this.pauseRef}>
                    {' '}
                    {pauseAriaLabel}
                </UncontrolledTooltip>
            </div>
        );
    }
}
